import type { CSSProperties } from 'react';
import type { CVData } from '../types/cv';

export type FontSizeKey =
    | 'name'
    | 'profession'
    | 'heading'
    | 'summary'
    | 'experience'
    | 'education'
    | 'skills'
    | 'languages'
    | 'contact'
    | 'interests'
    | 'references';

export const FONT_SIZE_PARTS: { key: FontSizeKey; label: string }[] = [
    { key: 'name', label: 'Nom' },
    { key: 'profession', label: 'Profession' },
    { key: 'heading', label: 'Titres de section' },
    { key: 'summary', label: 'Profil / résumé' },
    { key: 'experience', label: 'Expérience' },
    { key: 'education', label: 'Formation' },
    { key: 'skills', label: 'Compétences' },
    { key: 'languages', label: 'Langues' },
    { key: 'contact', label: 'Contact' },
    { key: 'interests', label: "Centres d'intérêt" },
    { key: 'references', label: 'Références' },
];

export const DEFAULT_FONT_SIZE = 100;
export const FONT_SIZE_MIN = 70;
export const FONT_SIZE_MAX = 150;
export const FONT_SIZE_STEP = 5;

export type FontSizes = Partial<Record<FontSizeKey, number>>;

export function getFontSize(style: CVData['style'] | undefined, key: FontSizeKey): number {
    const value = style?.fontSizes?.[key];
    return typeof value === 'number' ? value : DEFAULT_FONT_SIZE;
}

export function clampFontSize(value: number): number {
    return Math.min(FONT_SIZE_MAX, Math.max(FONT_SIZE_MIN, value));
}

/** Variables CSS consommées par `.cv-fs-*` */
export function fontSizeCssVars(style: CVData['style'] | undefined): CSSProperties {
    const vars: Record<string, string> = {};
    for (const { key } of FONT_SIZE_PARTS) {
        vars[`--cv-fs-${key}`] = String(getFontSize(style, key) / 100);
    }
    return vars as CSSProperties;
}
